import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FaHome,
  FaStore,
  FaBriefcase,
  FaAd,
  // FaLink,
  FaEllipsisH
} from 'react-icons/fa';

const CompanyBottomNavbar = ({ onMoreClick, isSidebarOpen = false }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: FaHome,
      path: '/company/dashboard/overview', // Assuming this is the company dashboard path
      color: '#3B82F6'
    },
    {
      id: 'brand',
      label: 'Brand',
      icon: FaStore,
      path: '/company/dashboard/brands', // Placeholder path
      color: '#3B82F6'
    },
    {
      id: 'campaign',
      label: 'Campaign',
      icon: FaBriefcase,
      path: '/company/dashboard/campaigns', // Placeholder path
      color: '#3B82F6'
    },
    {
      id: 'campaign-advertisement',
      label: 'Campaign Ads',
      icon: FaAd,
      path: '/company/dashboard/campaigns/advertising/create', // Placeholder path
      color: '#3B82F6'
    },
    // {
    //   id: 'affiliate-market',
    //   label: 'Affiliate',
    //   icon: FaLink,
    //   path: '/company/dashboard/affiliates/marketplace', // Placeholder path
    //   color: '#3B82F6'
    // }
    {
      id: 'more',
      label: 'More',
      icon: FaEllipsisH,
      path: '/company/dashboard/more', // Placeholder path
      color: '#3B82F6'
    }
  ];

  // Check if current path is active
  const isActivePath = (path) => {
    return location.pathname === path;
  };

  // Handle navigation
  const handleNavigation = (item) => {
    if (item.id === 'more') {
      onMoreClick?.();
      return;
    }

    const { path } = item;
    navigate(path);
  };

  return (
    <div
      className="
        fixed bottom-0 left-0 right-0 z-[120]
        bg-white border-t border-gray-200 shadow-lg
        md:hidden
      "
    >
      <div className="flex items-center justify-around py-1 px-1 lg:py-2 lg:px-2">
        {navItems.map((item) => {
          const IconComponent = item.icon;
          const isActive =
            item.id === 'more' ? isSidebarOpen : isActivePath(item.path);

          return (
            <button
              key={item.id}
              onClick={() => handleNavigation(item)}
              className="flex flex-col items-center justify-center py-1 px-1 lg:py-2 lg:px-3 min-w-0 flex-1"
            >
              <div className="flex flex-col items-center space-y-1">
                <IconComponent
                  className={`w-4 h-4 md:w-5 md:h-5 transition-colors duration-200 ${isActive ? 'text-blue-600' : 'text-gray-500'
                    }`}
                />
                <span
                  className={`text-[9px] md:text-xs font-medium text-center leading-tight
                              h-2 md:h-4 flex items-start justify-center
                              transition-colors duration-200
                              ${isActive ? 'text-blue-600' : 'text-gray-500'}
                              `}>
                  {item.label}
                </span>
                {/* <span 
                  className={`text-xs font-medium transition-colors duration-200 ${
                    isActive ? 'text-blue-600' : 'text-gray-500'
                  }`}
                >
                  {item.label}
                </span> */}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CompanyBottomNavbar;

